module.exports = __webpack_public_path__ + "images/stickers/taco-embarrassed@2x.ef769d2a141355c08d0e.png";